export class UserModel{

    constructor (obj){

        this.name = "";
        this.email = "";
        this.role = "";
        this.company = ""
       
        if (obj) {
            Object.assign(this, obj);
        }
    }
    
}

export const UserEventType = {
    LOG_OUT: 'logout',
    SWITCH_ACCOUNT: 'switchAccount'
}